import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getGukServers } from '../../actions/gukServers'
import Loader from '../../components/Loader'
import Table from '../../components/Table'
import { IoIosCheckmark, IoIosClose } from 'react-icons/io'
import styles from './styles.module.scss'

const BYTES_IN_GB = 1024 * 1024 * 1024

const formatGb = (bytes) => {
  if (bytes === null || bytes === undefined || isNaN(bytes)) return '-'
  return `${(Number(bytes) / BYTES_IN_GB).toFixed(1)} ГБ`
}

const utilClass = (percent) => {
  if (percent === null || percent === undefined || isNaN(percent)) return ''
  const p = Number(percent)
  if (p >= 90) return styles.utilDanger
  if (p >= 70) return styles.utilWarn
  return styles.utilOk
}

const GukServers = () => {
  const dispatch = useDispatch()
  const { data, loading } = useSelector(state => state.guk_servers)

  useEffect(() => {
    dispatch(getGukServers())
  }, [])

  const servers = Array.isArray(data) ? data : (data?.servers || [])

  if (loading && !servers.length) return <Loader />

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <h2>Сервера ГУК</h2>
      </div>

      <section className={styles.tableSection}>
        <Table maxHeight='82vh' minHeight='400px' dataLoaded={!loading && servers.length > 0}>
          <thead>
            <tr>
              <th>Имя</th>
              <th>Хост</th>
              <th>ID</th>
              <th>Доступен</th>
              <th>Обслуживание</th>
              <th>Проблемы</th>
              <th>Память</th>
              <th>Загрузка ОЗУ</th>
              <th>Диски</th>
            </tr>
          </thead>
          <tbody>
            {servers.length > 0 ? (
              servers.map((item) => (
                <tr key={item.hostid}>
                  <td>{item.zabbix_name || '-'}</td>
                  <td>{item.hostname || '-'}</td>
                  <td>{item.hostid || '-'}</td>
                  <td>
                    {Number(item.available) === 1 ? (
                      <IoIosCheckmark color='#00d900' size={24} />
                    ) : (
                      <IoIosClose color='red' size={24} />
                    )}
                  </td>
                  <td>
                    {Number(item.maintenance_status) === 1
                      ? <span className={styles.badgeWarn}>в обслуживании</span>
                      : <span className={styles.badgeOk}>активен</span>}
                  </td>
                  <td>
                    <span className={Number(item.active_problems) > 0 ? styles.problems : ''}>
                      {item.active_problems ?? 0}
                    </span>
                  </td>
                  <td>
                    {formatGb(item.memory_used)} / {formatGb(item.memory_total)}
                  </td>
                  <td>
                    <span className={utilClass(item.memory_util)}>
                      {item.memory_util !== undefined && item.memory_util !== null
                        ? `${Number(item.memory_util).toFixed(1)}%`
                        : '-'}
                    </span>
                  </td>
                  <td>
                    {Array.isArray(item.disks) && item.disks.length > 0 ? (
                      <ul className={styles.disks}>
                        {item.disks.map((d, i) => {
                          const usedPercent = d.pfree !== undefined && d.pfree !== null
                            ? (100 - Number(d.pfree)).toFixed(1)
                            : null
                          return (
                            <li key={`${item.hostid}-${d.fsname || i}`}>
                              <span className={styles.fsName}>{d.fsname}</span>
                              <span className={styles.fsSize}>
                                {formatGb(d.used)} / {formatGb(d.total)}
                              </span>
                              {usedPercent !== null && (
                                <span className={utilClass(usedPercent)}>{usedPercent}%</span>
                              )}
                            </li>
                          )
                        })}
                      </ul>
                    ) : '-'}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="9" className={styles.emptyMessage}>
                  Нет данных
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </section>
    </div>
  )
}

export default GukServers
